// Author YuJiaBei
// Date 2023-09-01 12:45:19

class EmAclRole {
    constructor({
                    id = null,
                    name = '',
                    type = '',
                    status = '',
                    aclLevel = '',
                    aclLevels = '',
                    deptAclLevel = '',
                    description = ''
                }
                    = {}) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.status = status;
        this.aclLevel = aclLevel;
        this.aclLevels = aclLevels;
        this.deptAclLevel = deptAclLevel;
        this.description = description;
    }
}

function newEntity() {
    return new EmAclRole();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'name',
            label: 'label.em.admin.emAclRole.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'type',
            label: 'label.em.admin.emAclRole.grid.type',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '管理员'},
                    {value: '2', text: '普通用户'}
                ]
            }
        },
        {
            key: 'status',
            label: 'label.em.admin.emAclRole.grid.status',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '启用'},
                    {value: '2', text: '冻结'}
                ]
            }
        },
        {
            key: 'aclLevelsText',
            label: 'label.em.admin.emAclRole.grid.aclLevelsText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deptAclLevel',
            label: 'label.em.admin.emAclRole.grid.deptAclLevel',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '无限制'},
                    {value: '4', text: '本部门及子部门'},
                    {value: '6', text: '仅本部门'}
                ]
            }
        },
        {
            key: 'description',
            label: 'label.em.admin.emAclRole.grid.description',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    nameFilter: '',
    typeFilter: '',
    statusFilter: '',
    aclLevelsFilter: [],
    aclLevelsInFilter: [],
    deptAclLevelFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nameFilter',
        label: 'label.em.admin.emAclRole.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'typeFilter',
        label: 'label.em.admin.emAclRole.filter.type',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '管理员'},
                {value: '2', text: '普通用户'}
            ]
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.admin.emAclRole.filter.status',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '冻结'}
            ]
        }
    },
    {
        key: 'aclLevelsFilter',
        label: 'label.em.admin.emAclRole.filter.aclLevels',
        disabled: false,
        form: {
            type: 'selectMultiple',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: false
            , options: [
                {value: '2', text: '查看'},
                {value: '3', text: '增加'},
                {value: '5', text: '修改'},
                {value: '7', text: '刪除'}
            ]
        }
    },
    {
        key: 'deptAclLevelFilter',
        label: 'label.em.admin.emAclRole.filter.deptAclLevel',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '无限制'},
                {value: '4', text: '本部门及子部门'},
                {value: '6', text: '仅本部门'}
            ]
        }
    }
];


const entityFormConfigs = [
    {
        key: 'name',
        label: 'label.em.admin.emAclRole.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'type',
        label: 'label.em.admin.emAclRole.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '管理员'},
                {value: '2', text: '普通用户'}
            ]
        }
    },
    {
        key: 'status',
        label: 'label.em.admin.emAclRole.entity.status',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '冻结'}
            ]
        }
    },
    {
        key: 'aclLevels',
        label: 'label.em.admin.emAclRole.entity.aclLevels',
        sortable: true,
        disabled: false,
        form: {
            type: 'selectMultiple',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: false
            , options: [
                {value: '2', text: '查看'},
                {value: '3', text: '增加'},
                {value: '5', text: '修改'},
                {value: '7', text: '刪除'}
            ]
        }
    },
    {
        key: 'deptAclLevel',
        label: 'label.em.admin.emAclRole.entity.deptAclLevel',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '无限制'},
                {value: '4', text: '本部门及子部门'},
                {value: '6', text: '仅本部门'}
            ]
        }
    },
    {
        key: 'description',
        label: 'label.em.admin.emAclRole.entity.description',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmAclRole, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
